export const getSelectedTab = ({ ui }) => ui.auctionTab.selected;

export const getFilters = ({ ui }) => ui.filters;

export const getAuctionsSorted = ({ ui }) => ui.sortFilterParam;

export const getPurchaseFilters = ({ ui }) => ui.purchaseFilters;
